import {
  ICertMasterPlatformAccessKeyValid,
  IError,
  IQueryHookOptions,
} from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { getCertMasterPlatformAccessKeyValid } from 'services';

type CertMasterPlatformAccessKeyValidFunction = UseMutateAsyncFunction<
  ICertMasterPlatformAccessKeyValid,
  IError,
  string
>;

type UseCertMasterPlatformAccessKeyValid = [
  CertMasterPlatformAccessKeyValidFunction,
  IQueryHookOptions,
];

export const useCertMasterPlatformAccessKeyValid =
  (): UseCertMasterPlatformAccessKeyValid => {
    const queryClient = useQueryClient();
    const { error, isError, isLoading, mutateAsync } = useMutation<
      ICertMasterPlatformAccessKeyValid,
      IError,
      string
    >((key: string) => getCertMasterPlatformAccessKeyValid(key), {
      onSuccess: () => {
        // queryClient.invalidateQueries(['profile', 'entitlements']);
      },
    });

    return [mutateAsync, { error, isError, isLoading }];
  };
